<div class="tasks-due-description mb-3">
  Displays all incomplete tasks organized by approaching due date.
</div>
<ngx-charts-bar-vertical
  [view]="chartConfig.view"
  [scheme]="chartConfig.colorScheme"
  [results]="chartConfig.data"
  [animations]="chartConfig.animations"
  [xAxis]="true"
  [yAxis]="true"
  [showGridLines]="true"
  [barPadding]="20"
  [roundEdges]="true"
  [legend]="true"
  [legendPosition]="'below'"
  [legendTitle]="'Legend'"
  (select)="onSelect($event)">
</ngx-charts-bar-vertical>
@if (loading) {
  <div class="float-end">
    <div class="loading-spinner"></div>
  </div>
}
